import { render, staticRenderFns } from "./ProductsWithShowMoreBtn.vue?vue&type=template&id=e2d28306&scoped=true&"
import script from "./ProductsWithShowMoreBtn.vue?vue&type=script&lang=js&"
export * from "./ProductsWithShowMoreBtn.vue?vue&type=script&lang=js&"
import style0 from "./ProductsWithShowMoreBtn.vue?vue&type=style&index=0&id=e2d28306&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d28306",
  null
  
)

export default component.exports